import React from "react";

const services = [
  {
    title: "Network Design & Cabling",
    description: "Custom-designed network layouts, structured cabling, and LAN/WAN solutions for seamless connectivity.",
    icon: "🌐",
  },
  {
    title: "Firewall & Security",
    description: "Enterprise-grade firewall installation, configuration, and intrusion prevention for maximum security.",
    icon: "🛡️",
  },
  {
    title: "CCTV & Surveillance",
    description: "Comprehensive CCTV installation and monitoring services for enhanced security and peace of mind.",
    icon: "📹",
  },
  {
    title: "Server Rack Setup",
    description: "Efficient and secure server room planning with patch panels, racks, and cooling systems.",
    icon: "🖥️",
  },
  {
    title: "Wi-Fi & Access Points",
    description: "Strong wireless coverage with centrally managed APs, roaming, and load-balanced Wi-Fi networks.",
    icon: "📶",
  },
  {
    title: "IT AMC & Support",
    description: "Annual Maintenance Contracts with on-site/off-site support, monitoring, and regular health checks.",
    icon: "🧰",
  },
];

const ServicesOverview = () => {
  return (
    <section className="bg-gray-50 py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Our Core Services
        </h2>
        <p className="text-gray-600 mb-12 max-w-3xl mx-auto">
          We offer a wide range of secure, scalable, and cost-effective IT networking solutions tailored to your business needs.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow hover:shadow-lg p-6 text-left transition"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800">
                {service.title}
              </h3>
              <p className="mt-2 text-gray-600 text-sm">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
